import styled from 'styled-components';
import withResponsive from 'shared/helpers/withResponsive';

export const Box = withResponsive(styled.div``);
